/**
 * This is the default layout while the preview is still as dark feature
 */
export const templateOriginalDefaultTempWikiMarkupDialog = ` 
    <form action='#' method='post' id="insert-wiki-markup-form" class="aui">
        <textarea class='monospaceInput textarea originalDefault' id='insert-wiki-textarea' name='wikitext'/>
    </form>
`;

/**
 * Dialog for the insert-wiki-markup
 *
 * NOTE the '<!-- -->', by default inline-blocks have a 4px space between each other
 * this will remove default inline-blocks spaces.
 * refer to http://css-tricks.com/fighting-the-space-between-inline-block-elements
 *
 */
export const templateWikiMarkupDialog = (translate) => `
    <p id="insert-wiki-info-title">${translate('tinymce.confluence.conf_wikimarkup_info_title')}</p>
    <form action='#' method='post' id="insert-wiki-markup-form" class="aui">
        <h3 class="wiki-title">
            <span id="insert-wiki-insert-title">${translate(
							'tinymce.confluence.conf_wikimarkup.insert.label',
						)}</span>
            <span id="insert-wiki-preview-title">${translate(
							'tinymce.confluence.conf_wikimarkup_preview_label',
						)}</span>
        </h3>
        <textarea class='monospaceInput textarea' id='insert-wiki-textarea' name='wikitext'></textarea>
        <div class='example-container' id='insert-wiki-textarea-preview'></div>
    </form>
`;

/**
 * This markup will be used to generate the preview iframe in order to allow
 * editor resources to be injected here.
 *
 */
export const templatePreviewWikiIframeContent = `
    <!DOCTYPE html>
    <html class="insert-wiki-markup-dialog">
        <head>
        </head>
        <body class="wiki-content previewWiki">
        </body>
    </html>
`;

/**
 * Sub Dialog for displaying errors within the insert-wiki-markup dialog
 *
 * @param warningMessage   - warning message to be displayed as the header
 * @param exceptionMessage - exception message returned from the server
 */
export const templateWikiErrorSubDialog = (warningMessage, exceptionMessage) => `
        <p class='warning'>
            ${warningMessage}
        </p>
        <p class='exception-report'>
            <span class='exceptionMessage'>
                ${exceptionMessage}
            </span>
        </p>
`;

/**
 * Will create the menu selector for wiki parser selection, will add the default selection as the first option.
 *
 * @param DEFAULT - options to be added to the selector
 * @param WIKI - all other wiki languages
 */
export const templateWikiParserSelector = (translate, DEFAULT, WIKI) => `
    <span class="wiki-parser-selector">
        <form action="#" method="post" id="d" class="aui">
            <select class="select medium-field" id="wiki-parser-selection-tool" name="wiki-parser-selection-tool" title="wiki parser selector">
                <option value="${DEFAULT.val}">${translate(DEFAULT.label)}</option>
                ${Object.keys(WIKI)
									.filter((key) => WIKI[key].val !== DEFAULT.val)
									.map(
										(key) =>
											`<option value="${WIKI[key].val}">${translate(WIKI[key].label)}</option>`,
									)}
            </select>
        </form>
    </span>
`;
